var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.88 31.03c-1.6-1.58-3.24-3.2-3.24-10.89 0-7.78-5.71-14.25-13.17-15.44a3 3 0 1 0-4.94 0A15.67 15.67 0 0 0 5.36 20.14c0 7.68-1.65 9.31-3.24 10.88A6.27 6.27 0 0 0 6.27 42H15a6 6 0 0 0 12 0h8.73a6.27 6.27 0 0 0 4.15-10.97zM21 44.25A2.25 2.25 0 0 1 18.75 42h4.5A2.25 2.25 0 0 1 21 44.25zm14.73-6.75H6.27a1.77 1.77 0 0 1-1.25-3.02c2.68-2.68 4.84-5.22 4.84-14.34C9.86 14 14.86 9 21 9c6.14 0 11.14 5 11.14 11.14 0 9.16 2.18 11.68 4.84 14.34a1.77 1.77 0 0 1-1.25 3.02z"
  })));
};
export default SvgBell;